import { render, staticRenderFns } from "./TeacherPlayer.vue?vue&type=template&id=314c83a0"
import script from "./TeacherPlayer.vue?vue&type=script&lang=js"
export * from "./TeacherPlayer.vue?vue&type=script&lang=js"
import style0 from "./TeacherPlayer.vue?vue&type=style&index=0&id=314c83a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports